// Environment brand: staging (ekubur.my / staging run.app / local dev) shows
// EKUBUR; production (akhirat.co) and any other host show AKHIRAT.
export function isEkuburBrand(): boolean {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  return (
    !/akhirat/.test(host) &&
    (/ekubur/.test(host) || host === 'localhost' || host.startsWith('127.') || host.startsWith('192.168.'))
  )
}

export function getBrand() {
  const isEkubur = isEkuburBrand()
  return {
    isEkubur,
    /** Display name with domain — "Ekubur.my" on staging, "Akhirat.co" in production. */
    name: isEkubur ? 'Ekubur.my' : 'Akhirat.co',
    /** Short display name — "Ekubur" on staging, "Akhirat" in production. */
    shortName: isEkubur ? 'Ekubur' : 'Akhirat',
    /** Uppercase wordmark used in the nav — "EKUBUR" or "AKHIRAT". */
    wordmark: isEkubur ? 'EKUBUR' : 'AKHIRAT',
  }
}
